import Pqp from "../3x1010/Pqp";
import Game from "./game/Game";

export default class PageDefault {
  init(payload) {
    this.game = new Game(payload);
    this.game.init();
  }
}
